"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyListItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
/**
 * @internal
 * @deprecated This component is deprecated use ListItem instead
 */
var LegacyListItem = /** @class */ (function (_super) {
    tslib_1.__extends(LegacyListItem, _super);
    function LegacyListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegacyListItem.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        var _g = this.props, item = _g.item, listItemClass = _g.listItemClass;
        var ListItemComponent = listItemClass;
        var itemType = (_c = (_b = (_a = item) === null || _a === void 0 ? void 0 : _a.source) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : null;
        if (itemType === "separator") {
            return react_1.default.createElement("div", { role: "list-item-separator", className: "gd-list-item gd-list-item-separator" });
        }
        if (itemType === "header") {
            var itemTitle = (_f = (_e = (_d = item) === null || _d === void 0 ? void 0 : _d.source) === null || _e === void 0 ? void 0 : _e.title) !== null && _f !== void 0 ? _f : null;
            return (react_1.default.createElement("div", { role: "list-item-header", className: "gd-list-item gd-list-item-header" }, itemTitle));
        }
        return react_1.default.createElement(ListItemComponent, tslib_1.__assign({}, item));
    };
    LegacyListItem.defaultProps = {
        item: {},
    };
    return LegacyListItem;
}(react_1.Component));
exports.LegacyListItem = LegacyListItem;
//# sourceMappingURL=LegacyListItem.js.map